export default {"src":"/_next/static/media/polygon.3fc41e44.svg","height":8,"width":10,"blurWidth":0,"blurHeight":0};